<template>
  <div style="height: 100%">
    <Header title="이전 상담 내역" :isBack="true" :isHistory="false"></Header>

    <div class="historyCon">
      <div class="listBox" v-show="roomList.length > 0">
        <div class="scroll">
          <div class="deleteBtn">
            <a @click="deleteHistory">
              <i class="UXicon-delete_outlined"></i>
              상담내역 전체 삭제
            </a>
          </div>

          <ul>
            <li v-for="(item, idx) in roomList" :key="idx" @click="chatroomDetail(item)">
              <div class="userImage">
                <p v-if="$isSeller" class="pic">
                  <img src="https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/icon_webchat_v2.png" />
                </p>

                <p v-else class="pic">
                  <img
                    :src="
                      headerStyle.toolbarAgentIconPath
                        ? encodeURI(headerStyle.toolbarAgentIconPath)
                        : 'https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/common/icon_webchat_v2.png'
                    "
                  />
                </p>

                <span v-if="item.chatRoomId === Number(currentlyChatRoom.id) && newMessage" class="newIcon">
                  <img src="https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/img/img_webchat_new_icon.png" alt="N" />
                </span>

                <p class="nowChatRoom" v-if="item.status == 'ACTIVE'">
                  <img src="https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/img/img_webchat_chating.png" alt="상담중" />
                </p>
              </div>

              <dl>
                <dt>
                  <p>{{ headerStyle.toolbarAgentName }}</p>

                  <span v-if="item.chatRoomId === currentlyChatRoom.id && newMessage">{{ printCreateMessageDate(lastMessage.lastMessageDate) }}</span>

                  <span v-else>{{ printCreateMessageDate(item.lastMessageDate) }}</span>
                </dt>

                <dd v-if="item.chatRoomId === currentlyChatRoom.id && newMessage">{{ parseMessage(lastMessage) }}</dd>

                <dd v-else>{{ parseMessage(item) }}</dd>
              </dl>
            </li>
          </ul>
        </div>

        <div class="backBtmBtn">
          <a
            class="customBtn"
            :style="{ color: headerStyle.toolbarTitleColor, backgroundColor: headerStyle.toolbarBackgroundColor }"
            @click="$router.go(-1)"
            v-html="
              currentlyChatRoom.status === 'ACTIVE' && currentlyChatRoom.id === chatRoomData.chatRoomId
                ? '<i class=\'UXicon-webchat_chating\'></i>상담중인 화면으로 이동'
                : '<i class=\'UXicon-return\'></i>이전 화면으로 이동'
            "
          ></a>
        </div>
      </div>

      <div class="notData" v-show="roomList.length === 0">
        <p>
          상담사와 상담한 내역이 없습니다.
          <br />
          상담하신 내역은 기기 별로 확인하실 수 있습니다.
          <a
            class="customBtn"
            :style="{ color: headerStyle.toolbarTitleColor, backgroundColor: headerStyle.toolbarBackgroundColor }"
            @click="$router.go(-1)"
          >
            <i class="UXicon-return"></i>
            이전 화면으로 이동
          </a>
        </p>
      </div>
      <span class="packageVersion">Powered by cloudgate v{{ packageVersion }}</span>
    </div>
  </div>
</template>

<script>
import helpers from '@/util/helpers';
import { mapGetters, mapMutations } from 'vuex';
import Header from '../../components/Header';
const packageConfig = require('@/../package.json');

export default {
  name: 'History',
  components: {
    Header
  },
  computed: {
    ...mapGetters(['chatRoomData', 'historyData'])
  },
  data() {
    return {
      headerStyle: {},
      brandQuery: window.sessionStorage.getItem('BRAND_QUERY') ? JSON.parse(window.sessionStorage.getItem('BRAND_QUERY')) : undefined,
      senderUid: window.localStorage.getItem(process.env.VUE_APP_LOGIN_ID)
        ? window.localStorage.getItem(process.env.VUE_APP_LOGIN_ID)
        : window.localStorage.getItem(process.env.VUE_APP_UUID_KEY),
      currentlyChatRoom: window.sessionStorage.getItem('CURRENTLY_CHATROOM') ? JSON.parse(window.sessionStorage.getItem('CURRENTLY_CHATROOM')) : {},
      roomList: [],
      newMessage: false,
      lastMessage: '',
      currentPage: 1,
      totalPages: 1,
      scrollInit: true,
      elm: null,
      isProgress: false,
      packageVersion: packageConfig.version
    };
  },
  mounted() {
    this.headerStyle = this.chatRoomData.headerStyle;
    this.getChatroomList();
    window.$mitt.on('subscribeBody', this.subscribeBody);
    this.elm = document.querySelector('.scroll');
    this.elm.addEventListener('scroll', this.scrollListener, false);
  },
  methods: {
    ...mapMutations(['setChatRoomData', 'setMessagesData', 'clearChatRoomData', 'setHistoryData', 'clearHistoryData']),
    listClear() {
      window.sessionStorage.removeItem('SCENARIO_CHECK_DATA');
      window.sessionStorage.removeItem('CURRENTLY_CHATROOM');

      this.senderUid = window.localStorage.getItem(process.env.VUE_APP_LOGIN_ID)
        ? window.localStorage.getItem(process.env.VUE_APP_LOGIN_ID)
        : window.localStorage.getItem(process.env.VUE_APP_UUID_KEY);

      this.currentlyChatRoom = {};
      this.currentPage = 1;
      this.totalPages = 1;
      this.clearHistoryData();
      this.clearChatRoomData();
      this.roomList = [];
      window.$mitt.emit('socket-connection-success');
    },
    deleteHistoryListData() {
      this.$http({
        url: `/api/external/webchat/${this.senderUid}/counseling`,
        method: 'DELETE',
        params: {
          brandKeyEncrypt: this.brandQuery.brandKey
        }
      }).then(({ data }) => {
        try {
          if (data.code === 0) {
            this.listClear();
          } else {
            this.$alertMsg(data.message);
          }
        } catch (e) {
          console.log(e);
        }
      });
    },
    deleteHistory() {
      this.$mitt.emit('DialogPopup', {
        useDialog: true,
        message:
          '<dl class="txt"><dt>상담 내역을 모두<br />삭제하시겠습니까?</dt><dd>현재 사용 중인 기기에서만 삭제되고,<br />진행 중인 상담은 상담이 종료됩니다.</dd></dl>',
        getBtnCount: 2,
        getButtonEvent: () => {
          this.$http({
            method: 'POST',
            url: '/api/external/webchat/closeChatRoom',
            data: {
              chatRoomId: this.chatRoomData.chatRoomId
            }
          }).then((res) => {
            if (res.data.code !== 0) {
              this.$mitt.emit('DialogPopup', {
                useDialog: true,
                message: '<dl class="txt"><dd>' + res.data.message + '</dd></dl>'
              });
            } else {
              this.deleteHistoryListData();
            }
          });
        }
      });
    },
    scrollListener() {
      if (this.scrollInit && this.elm.scrollTop + this.elm.clientHeight + 400 >= this.elm.scrollHeight && this.currentPage < this.totalPages) {
        this.currentPage = this.currentPage + 1;
        this.getChatroomList();
      }
    },
    parseMessage(data) {
      if (data.lastMessageType) {
        let showMessage = JSON.parse(data.lastMessage).text;
        switch (data.lastMessageType || 'TEXT') {
          case 'PHOTO':
            showMessage = '<<사진>>';
            break;
          case 'VIDEO':
            showMessage = '<<영상>>';
            break;
        }
        return (showMessage || JSON.parse(data.lastMessage).text).replace(/<\/?[^>]+(>|$)/g, '');
      } else {
        return '';
      }
    },
    chatroomDetail(item) {
      if (item.status === 'ACTIVE') {
        this.$router.go(-1);
      } else {
        this.$router.push({
          path: '/webChat/historyDetail',
          query: { chatRoomId: item.chatRoomId, agentName: item.agentName }
        });
      }
    },
    printCreateMessageDate(datetimeString) {
      return helpers.printTimeStampMessageFromDate(datetimeString);
    },
    getChatroomList() {
      this.scrollInit = false;
      this.$http({
        method: 'GET',
        url: `/api/external/webchat/${this.senderUid}/counseling/list`,
        params: {
          brandKeyEncrypt: this.brandQuery.brandKey,
          page: this.currentPage,
          size: 10,
          ascending: false
        }
      }).then((result) => {
        const res = result.data;
        if (res.code !== 0) {
          if (res.code === -411) {
            this.$router.history.go(-1);
          } else {
            this.roomList = [];
            this.$mitt.emit('DialogPopup', {
              useDialog: true,
              message: '<dl class="txt"><dd>' + res.message + '</dd></dl>'
            });
          }
        } else {
          this.currentPage = res.currentPage;
          this.totalPages = res.totalPages;
          this.roomList = this.roomList.concat(res.data);
          if (this.currentPage === 1 && this.roomList.length > 0) {
            this.isProgress = this.roomList[0].chatRoomId === this.currentlyChatRoom.id;
          }
          this.setHistoryData({
            roomList: this.roomList,
            currentPage: this.currentPage,
            totalPages: this.totalPages,
            isProgress: this.isProgress
          });
        }
        this.scrollInit = true;
        setTimeout(() => {
          this.scrollListener();
        });
      });
    },
    newChatMessageSubscribe(body) {
      const msgData = {
        agentName: body.data.senderName,
        channelName: body.data.channelName,
        chatRoomId: body.data.chatRoomId,
        lastMessage: body.data.content,
        lastMessageDate: body.data.createDate,
        lastMessageType: body.data.messageType,
        lastSenderType: body.data.senderType,
        status: 'ACTIVE'
      };
      if (body.data.messageType === 'START') {
        this.roomList.unshift(msgData);
        setTimeout(() => {
          this.currentlyChatRoom = JSON.parse(window.sessionStorage.getItem('CURRENTLY_CHATROOM'));
        }, 100);
      }
      if (
        body.data.messageType === 'START' ||
        (body.data.senderType === 'AGENT' && body.data.messageType !== 'END') ||
        (body.data.senderType === 'SYSTEM' && body.data.messageType === 'AUTO_CLOSE')
      ) {
        this.newMessage = true;
      }
      this.lastMessage = msgData;
      if (this.chatRoomData.messagesData.length > 0) {
        this.setMessagesData(this.chatRoomData.messagesData.concat(body.data));
      }
    },
    subscribeBody(body) {
      switch (body.changeType) {
        case 'NEW_CHAT_MESSAGE':
          if (body.data.chatRoomId === this.currentlyChatRoom.id) {
            this.newChatMessageSubscribe(body);
          }
          break;
        case 'CLOSE_CHAT_ROOM':
          if (body.data.chatRoomId === this.currentlyChatRoom.id) {
            this.setChatRoomData({
              chatRoomId: null,
              isEnd: true,
              headerStyle: this.chatRoomData.headerStyle,
              showInput: false,
              messagesData: this.chatRoomData.messagesData
            });
            this.newMessage = false;
            this.roomList[0].status = 'SUMMARY_WAITING';
          }
          break;
      }
    }
  },
  beforeDestroy() {
    window.$mitt.off('subscribeBody', this.subscribeBody);
  }
};
</script>
